package com.essntl.features.category.data.supabase

import com.essntl.features.category.domain.model.CategoryModel
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonPrimitive

internal fun CategoryModel.toRequestMap(): Map<String, JsonElement> {
    val requestMap = mutableMapOf<String, JsonElement>()

    requestMap["name"] = JsonPrimitive(name)

    if (iconUrl != null) {
        requestMap["icon_url"] = JsonPrimitive(iconUrl)
    }

    if (!serviceDynamicFields.isNullOrEmpty()) {
        requestMap["service_dynamic_fields"] = JsonArray(serviceDynamicFields!!.map { JsonPrimitive(it) })
    }

    if (qbCategoryId != null) {
        requestMap["qb_category_id"] = JsonPrimitive(qbCategoryId)
    }

    return requestMap
}
